<template>
    <div class="form">
        <Form ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="120">
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="商品名称"
                    prop="title">
                    <Input v-model="info.title"
                        :maxlength="256"
                        :readonly="readonly"
                        placeholder="">
                    </Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="商品图片"
                    prop="goodsImg">
                    <preview-upload v-model="info.goodsImg"
                        :readonly="readonly"></preview-upload>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="兑换积分"
                    prop="integral">
                    <input-number v-model="info.integral"
                        :allowDecimal="false"
                        :max="99999"
                        placeholder=""
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="商品总数"
                    prop="num">
                    <input-number v-model="info.num"
                        :allowDecimal="false"
                        :max="99999"
                        placeholder=""
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="个人限购数"
                    prop="limitNum">
                    <input-number v-model="info.limitNum"
                        :allowDecimal="false"
                        placeholder=""
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="是否上架"
                    prop="status">
                    <i-switch v-model="info.status"
                        size="large"
                        :true-value="1"
                        :false-value="0"
                        :readonly="readonly">
                        <span slot="open">是</span>
                        <span slot="close">否</span>
                    </i-switch>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="备注"
                    prop="remark">
                    <Input v-model="info.remark"
                        type="textarea"
                        :rows="3"
                        placeholder=""
                        :readonly="readonly">
                    </Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import PreviewUpload from '_c/preview-upload'
import { goodsView, goodsAdd, goodsUpdate } from "@/api/mall"

export default {
    name: "FormGoods",

    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },

    components: {
        PreviewUpload,
    },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            loading: false,

            info: {
                id: this.id,
                title: "", // 商品名称
                goodsImg: "", // 商品图片
                integral: "", // 兑换积分
                num: "", // 商品总数
                limitNum: "", // 个人限购数
                status: "", // 是否上架
                remark: "", // 备注
                ver: "", // 版本号
            },


        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can("update") : this.$can("add")
        },

        readonly() {
            return this.loading || !this.canSave
        },

        ruleValidate() {
            return {
                title: [
                    { required: true, message: "商品名称必填" },
                ],
                goodsImg: [
                    { required: true, message: "商品图片必填" },
                ],
                integral: [
                    { required: true, message: "兑换积分必填" },
                ],
                num: [
                    { required: true, message: "商品总数必填" },
                ],
            }
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return goodsView(this.id)
            } else {
                return Promise.resolve()
            }
        },
    },

    mounted() {
        var $info = this.$refs.info,
            btns = [{ type: "default", text: "关闭", name: "cancel" }]

        this.loading = true
        // 按钮定制
        if (this.canSave) {
            btns.unshift({ type: "primary", text: "保存", name: "confirm" })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([
                this.fetch(),
            ]).then(args => {
                var [view] = args

                if (view) {
                    var viewData = view.data
                    Object.keys(this.info).forEach(
                        name => (this.info[name] = viewData[name])
                    )
                }
            }).finally(() => {
                this.loading = false
                next()
            })
        })

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info.validate().then(() => {
                var formData = Object.assign({}, this.info)

                if (this.id) {
                    return goodsUpdate(formData)
                } else {
                    return goodsAdd(formData)
                }
            }).then(res => {
                if (this.id) {
                    this.$Message.success(this.$t("tips.update.success"))
                } else {
                    this.$Message.success(this.$t("tips.add.success"))
                }
            }).catch(err => {
                options.closeModal = false
            }).finally(() => {
                this.loading = false
                next()
            })
        })
    },
}
</script>
<style lang="less"
    scoped>
</style>